import type { ClassValue } from "clsx";
import baseClsx from "clsx";
import { twMerge } from "tailwind-merge";

export const clsx = (...args: ClassValue[]): ReturnType<typeof baseClsx> =>
  twMerge(baseClsx(args));
